export type PortNetworkSiteId = "port" | "gestoria" | "licencia";

export type PortNetworkSite = {
  id: PortNetworkSiteId;
  label: string;
  subtitle: string;
  href: string;
  image: string;
  accent: string;
  glow: string;
};

export const PORT_NETWORK_SITES: PortNetworkSite[] = [
  {
    id: "port",
    label: "Port de Premià",
    subtitle: "Puerto, actualidad y servicios",
    href: "https://portdepremia.com",
    image: "/images/ecosystem/port.jpg",
    accent: "from-sky-950/70 via-cyan-900/50 to-teal-900/55",
    glow: "shadow-sky-500/40",
  },
  {
    id: "gestoria",
    label: "Gestoría náutica",
    subtitle: "Trámites y documentación",
    href: "https://gestoria.portdepremia.com",
    image: "/images/ecosystem/gestoria.jpg",
    accent: "from-blue-950/70 via-indigo-900/50 to-violet-900/55",
    glow: "shadow-indigo-500/40",
  },
  {
    id: "licencia",
    label: "Titulaciones",
    subtitle: "Licencias y cursos náuticos",
    href: "https://licencia.portdepremia.com",
    image: "/images/ecosystem/licencia.jpg",
    accent: "from-emerald-950/70 via-teal-900/50 to-cyan-900/55",
    glow: "shadow-emerald-500/40",
  },
];

export const getPortNetworkSite = (id: PortNetworkSiteId) =>
  PORT_NETWORK_SITES.find((site) => site.id === id);
